//
// Class representing an auction
function AdsNinjaLogData(isPageLoad = true){

    this.__isPageLoad = isPageLoad;

    this.__hiddenData = {
        adEvents: {},
    };

    this.__data = {
        adEvents: {},
    };

    this.__timeProperties = {
        adEvents: {},
    };

    this.__initPageLoadData();
}

//
// Returns property.
AdsNinjaLogData.prototype.getProperty = function(key){

    return this.__data[key] || null;
}

//
// Sets property.
AdsNinjaLogData.prototype.setProperty = function(key, value){

    if(this.__data.hasOwnProperty(key)){

        return;
    }

    this.__data[key] = value;
};

//
// Sets property.
AdsNinjaLogData.prototype.setTimeProperty = function(key, currentTime, comparisonTimeKey){

    if(this.__timeProperties.hasOwnProperty(key)){

        return;
    }

    this.__timeProperties[key] = true;
    let value                  = currentTime - this.getHiddenProperty(comparisonTimeKey, 0);
    let timeToAuctionStart     = this.__getTimeToAuctionStart();
    let cumulative             = (this.__isPageLoad)? timeToAuctionStart + value : value;
    value                      = `${value.toFixed()}ms`;
    let data = {
        time: value,
        cumulative: `${cumulative.toFixed()}ms`,
    }
    this.__data[key]           = data
    return data;
};

//
// Returns property.
AdsNinjaLogData.prototype.getHiddenProperty = function(key, defaultValue = null){

    return this.__hiddenData[key] || defaultValue;
}

//
// Sets property.
AdsNinjaLogData.prototype.setHiddenProperty = function(key, value){

    if(this.__hiddenData.hasOwnProperty(key)){

        return;
    }

    this.__hiddenData[key] = value;
}

AdsNinjaLogData.prototype.differenceBetween = function(key1, key2){
    return (this.getHiddenProperty(key1, 0) - this.getHiddenProperty(key2, 0)).toFixed() + 'ms';
}

//
// Returns auction event.
AdsNinjaLogData.prototype.getAdEventData = function(key, event){

    if(!this.__data['adEvents'].hasOwnProperty(key) || !this.__data['adEvents'][key].hasOwnProperty(event)){

        return null;
    }

    return this.__data['adEvents'][key][event];
}

//
// Sets auction event.
AdsNinjaLogData.prototype.setAdEventData = function(key, event, currentTime, timeKey, comparisonTimeKey){

    if(this.__timeProperties['adEvents'].hasOwnProperty(key) && this.__timeProperties['adEvents'][key].hasOwnProperty(event)){

        return;
    }
    else if(!this.__timeProperties['adEvents'].hasOwnProperty(key)){

        this.__timeProperties['adEvents'][key] = {};
        this.__data['adEvents'][key]           = {};
    }
    
    this.__timeProperties['adEvents'][key][event] = true;
    var time                                      = currentTime - this.getHiddenProperty(timeKey, 0);
    var timeToAuctionStart                        = this.__getTimeToAuctionStart();
    var comparisonTime                            = this.getHiddenProperty(comparisonTimeKey, 0);
    var value                                     = currentTime - comparisonTime;
    value                                         = (this.__isPageLoad)? value + timeToAuctionStart : value;
    value                                         = `${value.toFixed()}ms`;
    let data = {
        time: `${time}ms`,
        cumulative: value,
    }
    this.__data['adEvents'][key][event]           = data;
    return data;
}

//
// Returns auction event.
AdsNinjaLogData.prototype.getExtraAdEventData = function(key, event){

    if(!this.__hiddenData['adEvents'].hasOwnProperty(key) || !this.__hiddenData['adEvents'][key].hasOwnProperty(event)){

        return null;
    }

    return this.__hiddenData['adEvents'][key][event];
}

//
// Sets auction event.
AdsNinjaLogData.prototype.setExtraAdEventData = function(key, event, value){

    if(!this.__hiddenData['adEvents'].hasOwnProperty(key)){

        this.__hiddenData['adEvents'][key] = {};
    }

    if(this.__hiddenData['adEvents'][key].hasOwnProperty(event)){

        return;
    }

    this.__hiddenData['adEvents'][key][event] = value;
}

// //
// // Sets auction event.
// AdsNinjaLogData.prototype.setAdsAndEventsToTrack = function(key, event, value){

//     if(!this.__hiddenData['adEvents'].hasOwnProperty(key)){

//         this.__hiddenData['adEvents'][key] = {};
//     }

//     if(this.__hiddenData['adEvents'][key].hasOwnProperty(event)){

//         return;
//     }

//     this.__hiddenData['adEvents'][key][event] = value;
// }

//
// Return log data.
AdsNinjaLogData.prototype.get = function(){
    if(this.__isPageLoad){

        var entry                                           = this.__hiddenData['pageLoad'];
        var encodedBodySize                                 = (entry.encodedBodySize || 0) / 1000;
        this.__data['pageLoad']['1. DOM Interactive']       = `${entry.domInteractive.toFixed()}ms`;
        this.__data['pageLoad']['2. DOM Complete']          = `${entry.domComplete.toFixed()}ms`;
        this.__data['pageLoad']['3. Page Finished Loading'] = `${entry.duration.toFixed()}ms`;
        this.__data['pageLoad']['Page Transfer Size']       = `${encodedBodySize.toFixed()}kB`;
        var initTime                                        = window.adsNinja.initTime || 0;
        initTime                                            = this.getHiddenProperty('auctionStart', 0) - initTime;

        this.setProperty(
            `0. AdsNinja Initialization`, {
                'time': `${initTime.toFixed()}ms`,
                'cumulative': `${this.__getTimeToAuctionStart().toFixed()}ms`,
            });
    }

    return this.__data;
}

AdsNinjaLogData.prototype.__getTimeToAuctionStart = function(){

    if(!this.__isPageLoad){

        return 0;
    }

    var initTime    = window.adsNinja.initTime || 0;
    initTime        = this.getHiddenProperty('auctionStart', 0) - initTime;
    var domComplete = this.getDomCompleted();

    return initTime + domComplete;
}

AdsNinjaLogData.prototype.getDomCompleted = function(){

    if(!this.__isPageLoad){ return 0; }

    var pageLoad = this.getHiddenProperty('pageLoad');
    return (pageLoad && pageLoad.domComplete)? pageLoad.domComplete : 0;
}

//
// Sets log data.
AdsNinjaLogData.prototype.__initPageLoadData = function(data){

    if(!this.__isPageLoad){

        return;
    }

    this.__hiddenData['pageLoad'] = {};
    this.__data['pageLoad']       = {};

    var entries = performance.getEntriesByType("navigation");

    for(var x in entries){

        var entry = entries[x];

        if(location.href !== entry.name){

            continue;
        }

        this.__hiddenData['pageLoad'] = entry;
    }
};

window.AdsNinjaLogData = AdsNinjaLogData;